import { createRequest, RequestConfig } from '../../../core/libs/api';
import { TOrder } from '../../orders/core/order';

const config: RequestConfig = {
  method: 'post',
  url: '/ws/api/cancel_order',
};

export const cancelOrderRequest = (
  order: Partial<TOrder> & { id: TOrder['id'] }
) =>
  createRequest({
    url: config.url,
    body: JSON.stringify(order),
    method: config.method,
  });
